<template>
<!-- 合同下载 -->
  <div class="homecontract_download text_center">
    <sec-title
      ac-text="合同"
      Text="下载"
      desc-text="为您提供各类专业合同范本，帮您提高工作效率，方便管理"
    />
    <div class="contract between">
      <div class="ify">
        <div
          class="ify_item center"
          v-for="(item, index) in catelist"
          :class="{ cur: index == current }"
          :key="index"
          @click="ify_click(item,item.id)"
        >
          <div class="ify_svg">
            <svg-icon icon-class="real_estate"></svg-icon>
          </div>
          <div>{{item.cat_name}}</div>
        </div>
      </div>
      <div class="con_list between wrap">
        <div class="con_item" v-for="(item, index) in contractlist.slice(0,9)" :key="index">
          <div class="title ellipsis">{{item.title}}</div>
          <div class="info between">
            <div class="det">
              <div class="d1">{{item.download_num}}人下载</div>
              <div class="d2"><span>¥</span>{{item.price}}</div>
              <div class="d3btn center">加入购物车</div>
            </div>
            <div><img src="~assets/home/ht.png" /></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import secTitle from "../components/secTitle";
export default {
  components: {
    secTitle,
  },
  data() {
    return {
      current: 0,
	  catelist:[],
	  contractlist:[]
    };
  },
  created() {
  	this.$http.home.contractcats().then(res => {
		this.catelist = res.data
		this.getlistdata(this.catelist[0].id)
	})
  },
  methods: {
	  getlistdata(id){
		this.$http.home.contractlist({
			cat_id:id
		}).then(res => {
			this.contractlist = res.data.data
		})  
	  },
    ify_click(idx,id) {
      this.current = idx;
	  this.getlistdata(id)
    },
  },
};
</script>

<style lang="scss" scoped>
.homecontract_download {
  padding: 50px 0;
  width: 1200px;
  margin: 0 auto;
  
  .contract {
    width: 100%;
    height: 540px;
    .ify {
      width: 220px;
      height: 100%;
      color: #ffffff;
      background-image: url("../../../assets/home/ify_bg.png");
      padding: 9px 0 0 6px;
      .ify_item {
        font-size: 18px;
        height: 72px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
        .ify_svg {
          margin-right: 18px;
          font-size: 27px;
        }
        &:hover {
          background-color: #fff;
          color: #0465ea;
          border-left: 6px solid #0465ea;
        }
      }
      .cur {
        background-color: #fff;
        color: #0465ea;
        border-left: 6px solid #0465ea;
      }
    }
    .con_list {
      height: 100%;
      flex: 1;

      .con_item {
        border-right: 1px solid #eeeeee;
        border-bottom: 1px solid #eeeeee;
        border-top: 1px solid #eeeeee;
        width: 33.3%;
        height: 180px;
        .title {
          padding: 20px 0 0 28px;
          font-size: 16px;
          font-family: Source Han Sans CN;
          color: #333333;
          text-align: left;
        }
        .info {
          padding-left: 28px;
          padding-right: 28px;
          .det {
            align-self: flex-start;
            text-align: left;
            .d1 {
              font-size: 12px;
              margin-top: 13px;
              color: #999999;
            }
            .d2 {
              font-size: 24px;
              line-height: 24px;
              color: #f25618;
              margin: 16px 0;
              span {
                font-size: 16px;
              }
            }
            .d3btn {
              width: 112px;
              height: 34px;
              font-size: 14px;
              color: #f25618;
              border: 1px solid #f25618;
              border-radius: 17px;
            }
          }
        }
      }
    }
  }
}
</style>